export default __webpack_public_path__ + "static/media/homepage-banner.9ddbd375.svg";